import { render, staticRenderFns } from "./ImportItemsDialog.vue?vue&type=template&id=46b5b150"
import script from "./ImportItemsDialog.vue?vue&type=script&lang=js"
export * from "./ImportItemsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports